import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	unassignedDisplayName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noUserDisplayName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	anonymousDisplayName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unassignedDisplayName: {
		id: 'issue-table-grouping.group-row.group-header.assignee-group-header.unassigned-display-name',
		defaultMessage: 'Unassigned',
		description:
			'Text used as a group name for unassigned issues when grouping items by assignee is enabled.',
	},
	noUserDisplayName: {
		id: 'issue-table-grouping.group-row.group-header.user-group-header.no-user-display-name',
		defaultMessage: 'No user',
		description:
			'Text used as a group name for empty user field values when grouping items by user fields is enabled.',
	},
	anonymousDisplayName: {
		id: 'issue-table-grouping.group-row.group-header.user-group-header.anonymous-display-name',
		defaultMessage: 'Anonymous',
		description:
			'Text used as a group name for anonymous issues when grouping items by assignee is enabled.',
	},
});
export default messages;
